import { CategoryItemProps } from "../interfaces/CategoryInterface";
import styles from "../styles/Category.module.scss";
import EventsIcon from "../../../public/assets/events-icon.svg";
import LifestyleApplicationsIcon from "../../../public/assets/lifestyle-applications-icon.svg";
import RestaurantPromotionsIcon from "../../../public/assets/restaurant-promotions-icon.svg";

export default function CategoryItem(props: CategoryItemProps) {
  const iconMapper = {
    events: <EventsIcon className={styles.icon}></EventsIcon>,
    "lifestyle applications": (
      <LifestyleApplicationsIcon
        className={styles.icon}
      ></LifestyleApplicationsIcon>
    ),
    "restaurant promotions": (
      <RestaurantPromotionsIcon
        className={styles.icon}
      ></RestaurantPromotionsIcon>
    ),
  };

  function categoryIcon() {
    return iconMapper[props.name.toLowerCase()];
  }

  return (
    <div className={styles.item_main}>
      {categoryIcon()}
      <p>{props.name}</p>
    </div>
  );
}
